const ConveyanceMasterKeys = {
  TITLE: "title",
  RESPONSE_TITLE: "responseTitle",
  CONVEYANCE_I_D: "conveyanceID",
  CARRIER_CODE: "carrierCode",
  CONVEYANCE_NO: "conveyanceNo",
  CONVEYANCE_TYPE: "conveyanceType",
  EMAIL: "email",
  ACE_ID: "aceId",
  VIN_NO: "vinNo",
  TRANSPONDER_NO: "transponderNo",
  STATUS: "status",
  SUBMISSION_DATE: "submissionDate",
  SUBMITTED_BY: "submittedBy",
  RESPONSE_DATE: "responseDate",
  CANCEL_BUTTON: "cancelButton",
  SUBMIT_BUTTON: "submitButton",
  SUBMIT_SENT_RECORDS: "submitSentRecords",
  SUBMIT_DIALOG_TITLE: "submitDialogTitle",
  SUBMIT_DIALOG_MESSAGE: "submitDialogMessage",
  SUBMIT_SUCCESS_MESSAGE: "submitSuccessMessage",
  SUBMIT_ERROR_MESSAGE: "submitErrorMessage",
  EDIT_BUTTON: "editButton",
  EDIT_SENT_RECORDS: "editSentRecords",
  DELETE_BUTTON: "deleteButton",
  DELETE_SENT_RECORDS: "deleteSentRecords",
  MASS_DELETE: "massDelete",
  MASS_DELETE_CONFIRM_MSG: "massDeleteConfirmMsg",
  MASS_DELETE_SUCCESS_MSG: "massDeleteSuccessMsg",
  MASS_DELETE_FAILED_MSG: "massDeleteFailedMsg",
  MASS_DELETE_INELIGIBLE_MSG: "massDeleteIneligibleMsg",
  MSG_FUNC_TYPE: "msgFuncType",
  MSG_FUNC_ADD: "msgFuncAdd",
  MSG_FUNC_DEACTIVATE: "msgFuncDeactivate",
  MSG_FUNC_MODIFY: "msgFuncModify",
  VIEW_BUTTON: "viewButton",
  LicensePlates: {
    TITLE: "licensePlates.title",
    LICENSE_PLATE_NO: "licensePlates.licensePlateNo",
    COUNTRYOF_REGISTRATION: "licensePlates.countryofRegistration",
    STATE: "licensePlates.state"
  },
  Validations:{
    MIN_LENGTH: "validations.minLength",
    MAX_LENGTH: "validations.maxLength",
    MAX_LENGTH_35: "validations.maxLength35",
    ALPHANUMERIC: "validations.alphaNumeric",
    ALPHANUMERIC_SPACE: "validations.alphaNumericSpace",
    EMAIL: "validations.email"
  },
  BACK_TO_CONVEYANCE_MASTER_LIST: "backToConveyanceMasterList",
  ADD_LICENSE_PLATE: "addLicensePlate",
  ADD_NEW: "addNew",
  LICENSE_PLATE: "licensePlate",
  CREATE_CONVEYANCE_MASTER: "createConveyanceMaster",
  CONVEYANCE_DELETED_SUCCESS_MSG: "conveyanceDeletedSuccessMsg"
}

export default ConveyanceMasterKeys
